import type { ReactNode } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import { ChartIcon, SettingsIcon } from "@signet/ui";
import { useMe } from "@signet/web-kit";
import { ChaturbateIcon } from "./logo.tsx";

/* The tabs along the top of CB Stats, as Research has them (Viral Vault, Niche check): Reporting, then Creator Setup. */

const TABS = [
  { to: "/cbstats", label: "Reporting", needs: "cbstats.stats:view", icon: ChartIcon },
  { to: "/cbstats/setup", label: "Creator Setup", needs: "cbstats.account:view", icon: SettingsIcon },
] as const;

export function CbPage({ tab, intro, actions, children }: { tab: (typeof TABS)[number]["label"]; intro?: ReactNode; actions?: ReactNode; children: ReactNode }) {
  const { can } = useMe();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const tabs = TABS.filter((t) => can(t.needs));
  const on = (to: string) => (to === "/cbstats" ? pathname === "/cbstats" || pathname === "/cbstats/" : pathname.startsWith(to));
  return (
    <div className="page cb-page">
      {tabs.length > 1 ? (
        <nav className="cb-tabs" aria-label="CB Stats">
          {tabs.map((t) => (
            <Link key={t.to} to={t.to as never} className={on(t.to) ? "on" : ""} aria-current={on(t.to) ? "page" : undefined}>
              <t.icon size={13} />
              {t.label}
            </Link>
          ))}
        </nav>
      ) : null}
      <header className="page-head">
        <div style={{ minWidth: 0 }}>
          <h1 className="cb-title">
            <span className="cb-title-icon">
              <ChaturbateIcon size={20} stroke={1.6} />
            </span>
            {tab}
          </h1>
          {intro ? <p>{intro}</p> : null}
        </div>
        {actions ? <div className="page-head-actions">{actions}</div> : null}
      </header>
      {children}
    </div>
  );
}
